import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
export const useViewportWidth = (initialWidth = typeof window === "undefined" ? 320 : window.innerWidth) => {
    const [viewportWidth, setViewportWidth] = useState(initialWidth);
    useEffect(() => {
        const updateWidth = debounce(() => {
            setViewportWidth(window.innerWidth);
        }, 200);
        window.addEventListener("resize", updateWidth);
        return () => {
            updateWidth.cancel();
            window.removeEventListener("resize", updateWidth);
        };
    });
    return viewportWidth;
};
